import { render, staticRenderFns } from "./LEditableText.vue?vue&type=template&id=2e70cf27"
import script from "./LEditableText.vue?vue&type=script&setup=true&lang=ts"
export * from "./LEditableText.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports